import { useAuthStore } from '@/stores/auth.store';

/** Permission keys the ticketbox POS gates on. */
export const PERM = {
  /** Entry to the POS at all. */
  OPERATE: 'sale.ticketbox.operate',
  /** Ask a supervisor to void a paid sale. */
  VOID_REQUEST: 'sale.void.request',
  /** Ask a supervisor to refund a paid sale (full or partial). */
  REFUND_REQUEST: 'sale.refund.request',
} as const;

/** Shown when an account lacks POS access (login refusal, RoleGate bounce). */
export const NO_POS_ACCESS_MESSAGE = 'Akun ini tidak memiliki akses kasir ticketbox.';

export interface PermissionSet {
  permissions: string[] | null | undefined;
  wildcards?: string[] | null;
}

/**
 * True when `key` is granted: an exact key, the global `*`, or a `prefix.*`
 * pattern covering it. A null set (not loaded yet) grants nothing.
 */
export function hasPermission(set: PermissionSet | null | undefined, key: string): boolean {
  if (!set || !set.permissions) return false;
  const all = [...(set.wildcards ?? []), ...set.permissions];
  for (const p of all) {
    if (p === '*' || p === key) return true;
    if (p.endsWith('.*') && key.startsWith(p.slice(0, -1))) return true;
  }
  return false;
}

/** May this account open the ticketbox POS? */
export function canOperatePos(set: PermissionSet | null | undefined): boolean {
  return hasPermission(set, PERM.OPERATE);
}

/** React hook: does the signed-in operator hold `key`? */
export function useCan(key: string): boolean {
  return useAuthStore((s) => hasPermission({ permissions: s.permissions, wildcards: s.wildcards }, key));
}
